import {Axios} from '../plugins/axios.js';


const state = {
}

const getters = {

}

const mutations =  {
}

const actions = {
  getTableDataAndProvinceAndCity ({ commit, state }, payload) {
    const data = payload.data;

      const getValueRepresentation = () => {
        let city_id       = data.city_id;
        let province_id   = data.province_id;
        let page          = data.page;
        let url           = '';

        if (city_id == -1) {
          data.city_id = '';
        }

        if (province_id == -1) {
          data.province_id = '';
        }

        page += -1
        data.page = page;

        for (let content in data) {
          url+=`&${content}=${data[content]}`
        }


        return new Axios()
        .get(`biav/v1/admin/club_checkout?${url}`)
        .then(response => {
          return response;
        })
        .catch(()=>{
          return 'error';
        })
      }

      const getProvinceAndCity= () => {
        return new Axios()
        .get(`location/v1/province?include_city=1`)
        .then(response => {
          return response;
        })
        .catch(()=>{
          return 'error';
        })
      }

      return Promise.all([getValueRepresentation(),getProvinceAndCity()])
      .then(res => {
        const setData = {
          tableData             : res[0],
          getProvinceAndCity    : res[1],
        }

        return setData
      })



  },

  updatePaySalon ({ commit, state }, payload) {
    const data = payload.data;

    return new Axios()
    .post(`biav/v1/admin/club_checkout/store`,data)
    .then(response => {
      return response;
    })
    .catch(()=>{
      return 'error';
    })
  },









}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
